<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> 
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.prescriptions', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body p-0">
                <b-form v-if="show">
                    <b-container class="p-0">
                        <div class="form-group col-md-12">
                            <span class="obligatoire">*</span>
                            <label for="etablissement_id">{{ $t('message.nomEtablissement') }}</label>
                            <autocomplete
                                :search="getEtablisssements"
                                placeholder="Rechercher l'établissement"
                                aria-label="Rechercher l'établissement"
                                :get-result-value="getValueEtablissement"
                                @submit="chooseEtablissement"
                            ></autocomplete>
                            <input type="hidden" name="etablissement_id" id="etablissement_id" v-model="$v.form.etablissement_id.$model" class="form-control" v-validate="'required'" :class="errors.has('etablissement_id') ? 'is-invalid' : ''"/>
                            <small id="emailHelp" class="form-text text-danger" v-if="$v.form.etablissement_id.$error">Rassurez-vous d'avoir sélectionné l'établissement</small> 
                        </div>
                        <b-row class="p-0">
                            <b-col sm="12">
                                <span class="obligatoire">*</span>
                                <b-form-group id="activity-group" :label="$t('message.activity')" label-for="activity">
                                    <multiselect v-model="$v.prescriptionForm.activity_id.$model" :options="missions" :multiple="true" :close-on-select="true" :clear-on-select="false" :preserve-search="true" :placeholder="$t('message.activities')" label="description_fr" track-by="id"></multiselect>
                                    <b-form-invalid-feedback v-if="$v.prescriptionForm.activity_id.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('activity_id')" style="color:red">
                                        {{getErrorsField('activity_id')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="date_prescription-group"
                                        :label="$t('message.prescriptionDate')"
                                        label-for="date_prescription">
                                    <b-form-input
                                            id="date_prescription"
                                            v-model="$v.prescriptionForm.date_prescription.$model"
                                            :state="$v.prescriptionForm.date_prescription.$dirty ? !(errorshasField('date_prescription') || $v.prescriptionForm.date_prescription.$error) : null"
                                            type="date"
                                            placeholder=""
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="errorshasField('date_prescription')">
                                        {{ getErrorsField('date_prescription') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.prescriptionForm.date_prescription.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>


                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="prescription-group"
                                        :label="$tc('message.drug',1)"
                                        label-for="prescription"
                                >
                                    <select id="medicaments" v-model="$v.prescriptionForm.medicament_id.$model"
                                            @change="clearErrorField('medicament_id')"
                                            class="form-control is-invalid retirerBordure"
                                            required
                                    >
                                        <option v-for="item in mMedicaments" :key="item.value" :value="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.prescriptionForm.medicament_id.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="errorshasField('medicament_id')">
                                        {{getErrorsField('medicament_id')}}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="voieAdmin-group"
                                        :label="$t('message.voieAdmin')"
                                        label-for="voieAdmin"
                                >
                                    <select id="voieAdmin" v-model="$v.prescriptionForm.voieAdmin.$model"
                                            @change="clearErrorField('voieAdmin')"
                                            class="form-control is-invalid retirerBordure"
                                            required
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in voiesAdmin" :key="item" :value="item">
                                            {{ item }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.prescriptionForm.voieAdmin.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="errorshasField('voieAdmin')">
                                        {{getErrorsField('voieAdmin')}}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="dose-group"
                                        :label="$t('message.dose')"
                                        label-for="dose"
                                >
                                    <b-form-input
                                            id="numero"
                                            v-model="$v.prescriptionForm.dose.$model"
                                            :state="$v.prescriptionForm.dose.$dirty ? !(errorshasField('dose') || $v.prescriptionForm.dose.$error) : null"
                                            placeholder=""
                                            step="0.01"
                                            type="number"
                                            @focus="clearErrorField('dose')"
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="$v.prescriptionForm.dose.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="errorshasField('dose')">
                                        {{ getErrorsField('dose') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="nombre-group"
                                        :label="$t('message.nombre')"
                                        label-for="nombre"
                                >
                                    <select id="nombre" v-model="$v.prescriptionForm.nombre.$model"
                                            @change="clearErrorField('nombre')"
                                            class="form-control is-invalid retirerBordure"
                                            required
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in nombres" :key="item" :value="item">
                                            {{ item }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.prescriptionForm.nombre.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="errorshasField('nombre')">
                                        {{getErrorsField('nombre')}}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="formulation-group"
                                        :label="$t('message.formulation')"
                                        label-for="formulation"
                                >
                                    <select id="formulation" v-model="$v.prescriptionForm.formulation.$model"
                                            @change="clearErrorField('formulation')"
                                            class="form-control is-invalid retirerBordure"
                                            required
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in formulations" :key="item" :value="item">
                                            {{ item }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.prescriptionForm.formulation.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="errorshasField('formulation')">
                                        {{getErrorsField('formulation')}}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="par-group"
                                        :label="$t('message.par')"
                                        label-for="par"
                                >
                                    <select id="par" v-model="$v.prescriptionForm.par.$model"
                                            @change="clearErrorField('par')"
                                            class="form-control is-invalid retirerBordure"
                                            required
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in pars" :key="item" :value="item">
                                            {{ item }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.prescriptionForm.par.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="errorshasField('par')">
                                        {{getErrorsField('par')}}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="date_fin-group"
                                        :label="$t('message.dateFin')"
                                        label-for="date_prescription">
                                    <b-form-input
                                            id="date_prescription"
                                            v-model="$v.prescriptionForm.date_fin.$model"
                                            :state="$v.prescriptionForm.date_fin.$dirty ? !(errorshasField('date_fin') || $v.prescriptionForm.date_fin.$error) : null"
                                            type="date"
                                            placeholder=""
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="errorshasField('date_fin')">
                                        {{ getErrorsField('date_fin') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.prescriptionForm.date_fin.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="info_comp-group"
                                        :label="$t('message.infoComp')"
                                        label-for="info_comp">
                                    <editor
                                            :api-key="tinyKey"
                                            id="traitement-propose"
                                            v-model="$v.prescriptionForm.info_comp.$model"
                                            :state="$v.prescriptionForm.info_comp.$dirty ? !(errorshasField('info_comp') || $v.prescriptionForm.info_comp.$error) : null"
                                            @focus="clearErrorField('info_comp')"
                                            :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                                    >
                                    </editor>
                                    <b-form-invalid-feedback v-if="errorshasField('info_comp')">
                                        {{ getErrorsField('info_comp') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.prescriptionForm.info_comp.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>


                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-container>
                        <b-row class="justify-content-center" v-if="can">
                            <b-button @click="onSubmitPrescription" variant="dark">
                                {{ $t('message.save')}} <span class="text-lowercase">{{  $tc('message.prescription',1) }}</span>
                            </b-button>
                        </b-row>
                        <div v-if="this.form.prescription.length>0" class="mt-5">
                            <div v-for="(prescription, index) in form.prescription" class="ml-2" :key="'prescription'+index">
                                <b-row class="mt-2">
                                    <b-col sm="9">
                                        <span>{{prescription.posologie.nombre}} {{prescription.posologie.formulation}}/{{prescription.posologie.par}} de {{prescription.nomMedicament}} par voie {{prescription.posologie.voie_admin}}</span>
                                    </b-col>
                                    <b-col sm="3">
                                        <button type="button" class="btn btn-warning btn-sm" @click="modifierPrescription(prescription)">Modifier</button>
                                        <button type="button" class="btn btn-danger btn-sm mt-1" @click="supprimerPrescription(prescription)">Supprimer</button>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                        <br>
                        <b-col sm="6" v-if="this.form.prescription.length>0">
                            <b-button @click="onSubmitPrescription" variant="primary">
                                {{ $t('message.save')}} <span class="text-lowercase">{{  $tc('message.prescriptions',1) }}</span>
                            </b-button>
                        </b-col>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from 'lodash';
    import moment from "moment";
    import {required} from 'vuelidate/lib/validators';
    import SlimSelect from "slim-select";
    import Drugs from "../Drug/Drugs";
    import {apiModel} from "../../api";
    import axios from 'axios';
    import AppConfig from "../../constants/AppConfig";
    import Editor from "@tinymce/tinymce-vue";
    import $ from 'jquery';
    import Swal from 'sweetalert2';
    import Multiselect from 'vue-multiselect';
    import Autocomplete from '@trevoreyre/autocomplete-vue'
    import '@trevoreyre/autocomplete-vue/dist/style.css'

    export default {
        name: "AddPrescription",
        components: {Drugs,  editor: Editor,Multiselect,
            Autocomplete,},
        computed: {
            ...mapGetters(["drugs", "errors", 'hasAdminRole',
                'hasMedecinControleRole', 'hasPraticienRole','hasAssistante']),

            can:function () {
                return this.hasAdminRole || this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
            },

            mMedicaments:function () {
                let mArray = [];
                _.forEach(this.drugs,function (drug) {
                    mArray.push({text:drug.nom_commercial,value:drug.id})
                });
                // console.log(this.drugs);
                // console.log(mArray);
            
                return mArray;
            }
        },
        data(){
            return {
                missions: [],
                tinyKey: AppConfig.tinyMceKey,
                plugins: [
                    'advlist autolink lists  image charmap',
                    'searchreplace visualblocks code fullscreen',
                    'print preview anchor insertdatetime media',
                    'paste code help wordcount table'
                ],
                toolbar: 'undo redo | formatselect | bold italic | \
                           alignleft aligncenter alignright | \
                           bullist numlist outdent indent | help',
                formulations:[
                    'Application',
                    'Ampoule',
                    'Collyre',
                    'Comprime',
                    'gelule',
                    'Goutte',
                    'Ovule',
                    'Sachet',
                    'Suppositoire',
                    'ml',
                    'mg',
                ],
                voiesAdmin:[
                    'Inhalation',
                    'Instillation',
                    'Vaginale',
                    'Oculaire',
                    'PO',
                    'IV',
                    'IM',
                    'SC',
                    'Intradermique',
                    'Rectale',
                    'Cutanée',
                    'Sublinguale',
                    'Transdermique',],
                nombres:[
                    '1',
                    '2',
                    '3',
                    '4',
                    '5',
                    '6',
                    '7',
                    '8',
                    '9',
                    '10',
                    '11',
                    '12',
                ],
                // mMedicaments:[],
                pars:[
                    'Minute',
                    'Heure',
                    'Jour',
                    'Semaine',
                    'Mois',
                ],
                show:true,
                showDrugForm:false,
                showDrugList:false,
                file:this.$route.params.file,
                medicaments:[],
                form:{
                    prescription:[],
                    dossier_medical_id:'',
                },
                prescriptionForm: {
                    date_prescription: moment((new Date())).format('YYYY-MM-DD'),
                    formulation:'',
                    medicament_id:null,
                    dose:'',
                    voieAdmin:'',
                    activity_id: '',
                    etablissement_id:null,
                    nombre:'',
                    par:'',
                    info_comp:'',
                    date_fin:'',
                }
            }
        },

        methods: {
            getEtablisssements(input){
                return new Promise(resolve => {
                    if (input.length < 2) {
                    return resolve([])
                    }
                    fetch(AppConfig.apiUrl+'/search/etablissements/'+input, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
                    .then(res => res.json())
                    .then(res => {
                        resolve(res.etablissements)
                    }).catch(error => {
                        console.log('error ', error);
                    })
                })
            },
            getValueEtablissement(result) {
                return result.name
            },
            chooseEtablissement(result) {
                this.form.etablissement_id = result.id;
            },
            
            getGroupeActivites: function () {
                axios
                    .get(AppConfig.apiUrl + "/mission/list")
                    .then((res) => {this.missions = res.data.activites.map((x )=> ({
                        id: x.id,
                        description_fr: x.description_fr
                    }))})
                    .catch((error) => {window.console.log(error)});
            },
            modifierPrescription(prescription){
                this.mMedicaments = [];
                this.mMedicaments.push({text:prescription.nomMedicament, value:prescription.medicament_id});
                this.prescriptionForm.medicament_id = prescription.medicament_id;
                // console.log( this.mMedicaments)
                // console.log( this.prescriptionForm.medicament_id)
                $('#medicaments').val
            },
            supprimerPrescription(prescription){

            },
            onSubmitPrescription(evt){
                evt.preventDefault();
                let self = this;
                this.$v.prescriptionForm.$touch();

                if(!this.$v.prescriptionForm.$invalid){
                    let argPrescription = {};
                    let medicament_id = _.filter(self.mMedicaments,function (medicament) {
                        return  medicament.value == self.prescriptionForm.medicament_id;
                    });
                    let medicamentFind = _.find(this.form.prescription,function (prescription) {
                        return prescription.medicament_id == self.prescriptionForm.medicament_id;
                    });
                    if (_.isUndefined(medicamentFind)){
                        argPrescription.medicament_id = this.prescriptionForm.medicament_id;
                        argPrescription.nomMedicament = medicament_id[0].text;
                        argPrescription.info_comp = this.prescriptionForm.info_comp;
                        argPrescription.date_fin = this.prescriptionForm.date_fin;
                        argPrescription['posologie'] = {};
                        argPrescription.posologie.dose = this.prescriptionForm.dose;
                        argPrescription.posologie.formulation = this.prescriptionForm.formulation;
                        argPrescription.posologie.voie_admin = this.prescriptionForm.voieAdmin;
                        argPrescription.posologie.nombre = this.prescriptionForm.nombre;
                        argPrescription.posologie.par = this.prescriptionForm.par;
                        this.form.prescription.push(argPrescription);
                        this.$v.prescriptionForm.medicament_id.$model = "";
                        this.$v.prescriptionForm.info_comp.$model='';
                        this.$v.prescriptionForm.date_fin.$model='';
                        this.$v.prescriptionForm.dose.$model='';
                        this.$v.prescriptionForm.formulation.$model='';
                        this.$v.prescriptionForm.voieAdmin.$model='';
                        this.$v.prescriptionForm.nombre.$model='';
                        this.$v.prescriptionForm.par.$model='';
                        this.$nextTick(() => { this.$v.$reset() });
                        $(".ss-deselect").click();
                    }
                    else{
                        Swal.fire('Ce médicament est déjà prescrit');
                    }

                    // let args = {
                    //     dossier_medical_id : this.file,
                    //     date_prescription:this.prescriptionForm.date_prescription,
                    //     medicaments:this.prescriptionForm.medicaments,
                    // };

                    // let successMessage = this.$i18n.t('message.prescriptionCreated');
                    // let errorMessages = {
                    //     generic: this.$i18n.t('message.genericError'),
                    //     error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    // };
                    //
                    // this.$store.dispatch('createPrescription', { args, errorMessages, successMessage });
                }
            },

            listeDesMedicaments() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getDrugs', { args : args });
            },


            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },
        created() {
            $(".ss-deselect").click();
        },

        mounted() {
            this.getGroupeActivites();
            this.listeDesMedicaments();

            new SlimSelect({
                select: '#formulation',
            });
            new SlimSelect({
                select: '#voieAdmin',
            });

            new SlimSelect({
                select: '#nombre',
            });

            new SlimSelect({
                select: '#par',
                allowDeselect: true,
            });

            let self = this;
            new SlimSelect({
                select: '#medicaments',
                searchingText: 'Searching...', // Optional - Will show during ajax request
                ajax: function (search, callback) {
                    // Check search value. If you dont like it callback(false) or callback('Message String')
                    if (search.length <= 2) {
                        callback('Need 3 characters')
                        return
                    }

                    let args = {}
                    let baseUrl = AppConfig.apiUrl;
                    let localToken = localStorage.getItem('ms-token');
                    // Perform your own ajax request here
                    let customHeaders = {};
                    customHeaders["headers"] = {};
                    customHeaders["headers"]["Authorization"] = "Bearer " + localToken;
                    axios.get(baseUrl+apiModel.Medicament.Rechercher.url+search, {
                        headers: {
                            "Authorization" : `Bearer ${localToken}`,
                            "Accept": "application/json, text/plain, */*",
                            "Content-Type": "application/json"
                        } })
                        .then(function (response) {
                            // let data = [];
                            let medicaments = response.data.medicaments;
                            self.mMedicaments = [];
                            for (let i = 0; i < medicaments.length; i++) {
                                // data.push({text: medicaments[i].nom_specialite});
                                self.mMedicaments.push({text:medicaments[i].nom_commercial,value:medicaments[i].id});
                            }

                            // Upon successful fetch send data to callback function.
                            // Be sure to send data back in the proper format.
                            // Refer to the method setData for examples of proper format.
                            // callback(data)
                            callback(self.mMedicaments);
                            search = '';

                        })
                        .catch(function (error) {
                            // If any erros happened send false back through the callback
                            callback(false)
                        })
                }
            });

        },

        validations() {
            return{
                prescriptionForm: {
                    activity_id:{
                    required
                        },
                    etablissement_id:{required},
                    date_prescription: {required},
                    formulation:{required},
                    medicament_id:{required},
                    dose:{required},
                    voieAdmin:{required},
                    nombre:{required},
                    par:{required},
                    info_comp:{},
                    date_fin:{},
                },
            }
        }
    }
</script>

<style scoped>

</style>